import { createFileRoute } from "@tanstack/react-router";

import { PraxaProductionSurface } from "../components/praxa/PraxaProductionSurface";

export const Route = createFileRoute("/w/$workspaceId/production/$appId")({
  component: PraxaProductionAppRoute,
});

function PraxaProductionAppRoute() {
  const { appId, workspaceId } = Route.useParams();
  return <PraxaProductionSurface appId={appId} workspaceId={workspaceId} />;
}
